import AceleresTeamPresenceAPI from 'dashboard/api/aceleresTeamPresence';

// Aceleres: heartbeat de atividade real.
// Envia um "ping de atividade" enquanto o usuario estiver de fato interagindo
// (mouse/teclado/scroll/toque) e com a aba visivel. Uma aba aberta e parada
// deixa de pingar -> o backend marca a sessao como ociosa apos o IDLE_THRESHOLD.
// Isso alimenta o painel "Equipe Online" (presenca real: ativo/ocioso/offline).

const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'wheel',
];

const SEND_INTERVAL_MS = 25000; // tenta enviar a cada 25s
const ACTIVE_WINDOW_MS = 30000; // so envia se houve input nos ultimos 30s

let lastActivityAt = 0;
let intervalId = null;
let started = false;

const markActivity = () => {
  lastActivityAt = Date.now();
};

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') markActivity();
};

const tick = async () => {
  try {
    const visible = document.visibilityState === 'visible';
    const recentlyActive = Date.now() - lastActivityAt < ACTIVE_WINDOW_MS;
    if (visible && recentlyActive) {
      await AceleresTeamPresenceAPI.activityPing();
    }
  } catch (error) {
    // silencioso: o heartbeat nunca deve quebrar a UI
  }
};

export const startAceleresActivityHeartbeat = () => {
  if (started || typeof window === 'undefined') return;
  started = true;
  markActivity(); // ao carregar a tela ja conta como atividade
  ACTIVITY_EVENTS.forEach(evt =>
    window.addEventListener(evt, markActivity, { passive: true })
  );
  document.addEventListener('visibilitychange', onVisibilityChange);
  intervalId = window.setInterval(tick, SEND_INTERVAL_MS);
  tick();
};

export const stopAceleresActivityHeartbeat = () => {
  if (!started) return;
  started = false;
  ACTIVITY_EVENTS.forEach(evt => window.removeEventListener(evt, markActivity));
  document.removeEventListener('visibilitychange', onVisibilityChange);
  if (intervalId) {
    window.clearInterval(intervalId);
    intervalId = null;
  }
};
